import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';
import routes from './routers';

Vue.use(Router);

const router = new Router({
  routes,
});
router.beforeEach((to, from, next) => {

    if(to.name!=='Login'){
       
        if(store.state.user===null){
            next('/login')
        }else{
            next() 
        }
        
    }else{
        next();
    }

});
const routerPath = router.push;
router.push = function push(location) {
  return routerPath.call(this, location).catch(() => console.log('路由重复跳转'));
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js